import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const BoxLoadingContainer = styled.div`
  background-color: ${props=> props.size==="small"?'':Variables.colors.complementary};
  opacity: 0.7;
  display: block;
  margin: 0 auto;

  .spinner {
    width: ${props=> props.size==="small"?'15px':'72px'};
    height: ${props=> props.size==="small"?'15px':'72px'};
  
    position: relative;
    margin: 100px auto;
  }
  .double-bounce1,
  .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${props=> props.size==="small"?Variables.colors.complementary_900:Variables.colors.primary_400};
    opacity: 0.3;
    position: absolute;
    top: 0;
    left: 0;

    -webkit-animation: sk-bounce 2s infinite ease-in-out;
    animation: sk-bounce 2s infinite ease-in-out;
  }
`;
